/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetPageDetailResponse,
  GetPageIdResponse,
  UtxNotionPageApiGetPageIdParams
} from './schema'



export const utxNotionPageApiGetPageDetailById = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetPageDetailResponse[]>> => {
    return axios.get(
      `/notion-page/${id}`,options
    );
  }


export const getUtxNotionPageApiGetPageDetailByIdQueryKey = (id: string,) => [`/notion-page/${id}`];

    
export type UtxNotionPageApiGetPageDetailByIdQueryResult = NonNullable<Awaited<ReturnType<typeof utxNotionPageApiGetPageDetailById>>>
export type UtxNotionPageApiGetPageDetailByIdQueryError = AxiosError<unknown>

export const useUtxNotionPageApiGetPageDetailById = <TData = Awaited<ReturnType<typeof utxNotionPageApiGetPageDetailById>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxNotionPageApiGetPageDetailById>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxNotionPageApiGetPageDetailByIdQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxNotionPageApiGetPageDetailById>>> = ({ signal }) => utxNotionPageApiGetPageDetailById(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxNotionPageApiGetPageDetailById>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxNotionPageApiGetPageId = (
    params: UtxNotionPageApiGetPageIdParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetPageIdResponse[]>> => {
    return axios.get(
      `/notion-page`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxNotionPageApiGetPageIdQueryKey = (params: UtxNotionPageApiGetPageIdParams,) => [`/notion-page`, ...(params ? [params]: [])];

    
export type UtxNotionPageApiGetPageIdQueryResult = NonNullable<Awaited<ReturnType<typeof utxNotionPageApiGetPageId>>>
export type UtxNotionPageApiGetPageIdQueryError = AxiosError<unknown>

export const useUtxNotionPageApiGetPageId = <TData = Awaited<ReturnType<typeof utxNotionPageApiGetPageId>>, TError = AxiosError<unknown>>(
 params: UtxNotionPageApiGetPageIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxNotionPageApiGetPageId>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxNotionPageApiGetPageIdQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxNotionPageApiGetPageId>>> = ({ signal }) => utxNotionPageApiGetPageId(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxNotionPageApiGetPageId>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

